import { TooltipConfig } from './../../models/ui-config';
import { TooltipPosition } from './../enums/tooltip-position.enum';
import { OnDestroy, AfterViewInit } from '@angular/core';
import {
  Directive,
  Input,
  ElementRef,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { TooltipComponent } from '../components/tooltip/tooltip.component';

@Directive({
  selector: '[raMatLabelTooltip]',
  standalone: false,
})
export class MatLabelTooltipDirective implements AfterViewInit, OnDestroy {
  @Input() raMatLabelTooltip: string;
  @Input() tooltipPos: string;
  @Input() tooltipConfig?: TooltipConfig;
  private component: ComponentRef<TooltipComponent>;
  private interval: any;
  constructor(
    private elementRef: ElementRef,
    private vcRef: ViewContainerRef,
  ) {}

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.raMatLabelTooltip || this.tooltipConfig?.tooltipDesc) {
        const matLabelParent = (
          this.elementRef.nativeElement.parentElement as HTMLElement
        ).querySelector('.mat-mdc-floating-label');
        if (!matLabelParent) {
          return;
        }
        const matLabel = matLabelParent.children[0] as HTMLElement;
        this.setStylesForMatLabel(matLabel);
      }
    }, 255);
  }

  setStylesForMatLabel(matLabel: HTMLElement): void {
    if (matLabel && matLabel.innerText) {
      const styles: any = {
        position: 'absolute',
        top: '-20px',
        right: '0px',
        color: 'gray',
        fontSize: '14px',
        ['z-index']: 1,
      };
      this.interval = setInterval(() => {
        if (matLabel.getBoundingClientRect().width) {
          clearInterval(this.interval);
          styles.left = matLabel.getBoundingClientRect().width + 12 + 'px';
          delete styles.right;
          // const hostContainer = this.crf.resolveComponentFactory(TooltipComponent);
          // this.component = this.vcRef.createComponent(hostContainer);
          this.component = this.vcRef.createComponent(TooltipComponent);
          this.component.instance.tooltipDesc =
            this.raMatLabelTooltip || this.tooltipConfig.tooltipDesc;
          this.component.instance.styles = Object.assign(
            styles,
            this.tooltipConfig?.styles || {},
          );
          this.component.instance.tooltipPos =
            this.tooltipPos ||
            this.tooltipConfig.tooltipPos ||
            TooltipPosition.Right;
        }
      }, 50);
    }
  }

  ngOnDestroy(): void {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
